module.exports = __webpack_public_path__ + "img/male-infant-figure.8fa6628c.svg";